export default __webpack_public_path__ + "static/media/primary.20ad751541b2e403c9624f2eec2b0afd.svg";